import React from 'react';

const LoadingSpinner = ({ show, absolutePosition = false }) => {
    const position = absolutePosition ? 'absolute' : 'fixed';

    const spinnerStyle = {
        overlay: {
            position: position,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        spinner: {
            width: '15vw',
            height: '15vw',
            maxWidth: '100px',
            maxHeight: '100px',
            border: '5px solid #f3f3f3',
            borderTop: '5px solid goldenrod',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
        },
    };

    const spinKeyframes = `
        @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
        }
    `;

    return show ? (
        <div style={spinnerStyle.overlay}>
            <style>{spinKeyframes}</style>
            <div style={spinnerStyle.spinner}></div>
        </div>
    ) : null;
};

export default LoadingSpinner;
